import { IScoredSection } from '~/pages/anatomyV2/libs/scoredSections'
import { TAnswers } from '~/shared/types/commonTypes'

// If every question in a section was answered incorrectly, the user still
// gets a small consolation score instead of a discouraging 0.
const MIN_SECTION_SCORE = 5

export const calculateSectionScore = (
  { scoredPageIds, correctAnswersRegistry, pointsPerQuestion }: IScoredSection,
  answers: Partial<TAnswers> | null,
) => {
  const total = scoredPageIds.reduce((sum, pageId) => {
    const isCorrect = answers?.[pageId] === correctAnswersRegistry[pageId]
    return isCorrect ? sum + pointsPerQuestion : sum
  }, 0)

  return total === 0 ? MIN_SECTION_SCORE : total
}

export const calculateTotalScore = (
  sections: IScoredSection[],
  answers: Partial<TAnswers> | null,
) =>
  sections.reduce(
    (total, section) => total + calculateSectionScore(section, answers),
    0,
  )
